import React from "react";
import SEO from "../../components/seo";
import Layout from "../../components/layout";
import LaoResourcesContent from "../../components/resources/lao-resources";
import { State } from "../../components/resources/context";

const ProgramResourcesPage = ({location}) => {
  const params = new URLSearchParams(location.search);
  const title = params.get("title");
  const category = params.get("category");
  const type = params.get("type");
  return (
  <Layout>
    <SEO title="LAO Resources" />
    <State>
      <LaoResourcesContent params={params}/>
    </State>
  </Layout>
);
  }

export default ProgramResourcesPage;
